<div [class]="wrapper_classes" class="unselectable">

	<div class="flex_center gap_small" aria-label="Paginador" role="menu" tabindex="0">
		<button mat-button color="accent" class="only_gt_sm" [ngClass]="{invisible: pagination.current_page == 1}" (click)="previous()" [disabled]="bLoading" aria-label="Página anterior">
			<mat-icon>chevron_left</mat-icon>
			Anterior
		</button>
		<button mat-icon-button color="accent" class="only_lt_sm" [ngClass]="{invisible: pagination.current_page == 1}" (click)="previous()" [disabled]="bLoading" aria-label="Página anterior">
			<mat-icon>chevron_left</mat-icon>
		</button>

		<div class="align_items_center gap_very_small">
			<p class="square bg_white_medium_emphasis flex_center color_black_medium_emphasis">
				<ng-container *ngIf="!bLoading; else loading">
					{{pagination.current_page}}
				</ng-container>
				<ng-template #loading>
					<mat-spinner diameter="18" strokeWidth="2" class="primary_500 faster"></mat-spinner>
				</ng-template>
			</p>
			<p class="body1 color_black_inactive">de</p>
			<p class="square bg_white_medium_emphasis color_black_medium_emphasis">{{pagination.last_page}}</p>
		</div>

		<button mat-icon-button color="accent" class="only_lt_sm" [ngClass]="{invisible: pagination.current_page == pagination.last_page}" (click)="next()" [disabled]="bLoading" aria-label="Siguiente página">
			<mat-icon>chevron_right</mat-icon>
		</button>
		<button mat-button color="accent" class="only_gt_sm" [ngClass]="{invisible: pagination.current_page == pagination.last_page}" (click)="next()" [disabled]="bLoading" aria-label="Siguiente página">
			Siguiente
			<mat-icon iconPositionEnd>chevron_right</mat-icon>
		</button>
	</div>
</div>